(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("__mylog", [], factory);
	else if(typeof exports === 'object')
		exports["__mylog"] = factory();
	else
		root["__mylog"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
exports.ready = ready;
exports.getProtocol = getProtocol;
exports.guid = guid;
exports.isObject = isObject;
exports.isURL = isURL;
exports.timestamps = timestamps;
exports.objectToUrl = objectToUrl;
/**
 * 绑定事件
 * @param {object}   elem 元素
 * @param {string}   type 事件类型
 * @param {function} callback 回调
 */
function on(elem, type, callback) {
  if (elem.addEventListener) {
    elem.addEventListener(type, callback);
  } else {
    elem.attachEvent('on' + type, function () {
      callback.call(elem);
    });
  }
}

/**
 * 绑定事件
 * @param {object}   elem 元素
 * @param {string}   type 事件类型
 * @param {function} callback 回调
 */
function off(elem, type, callback) {
  if (elem.removeEventListener) {
    elem.removeEventListener(type, callback);
  } else {
    elem.attachEvent('off' + type, callback);
  }
}

/**
 * DOM渲染完成
 * @param {function} fn
 */
function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState !== 'loading') {
        fn();
      }
    });
  }
}

/**
 * 获取协议url
 * @param  {string} url  链接
 * @return {string}
 */
function getProtocol() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;

  return (/^https/i.test(url) ? 'https' : 'http'
  );
}

/**
 * 唯一标识符
 * @param {string} 返回标识
 */
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/**
 * 判断是否是对象
 * @param {string} str
 * @return {boolean}
 */
function isObject(str) {
  return Object.prototype.toString.call(str) === '[object Object]';
}

/**
 * 判断是不是带协议的网址（//开头或者包含://）
 * @return {boolean}
 */
function isURL(url) {
  return (/^\/\//.test(url) || /^[a-zA-z]+:\/\/[^\s]*/.test(url)
  );
}

/**
 * 生成时间戳
 */
function timestamps() {
  return +new Date();
}

/**
 * 对象转url参数
 * @param {*} obj
 */
function objectToUrl(obj) {
  if (!isObject(obj)) {
    return '';
  }

  var str = '';
  Object.keys(obj).map(function (key, index) {
    str += '' + (index === 0 ? '?' : '&') + key + '=' + encodeURIComponent(obj[key]);
  });

  return str;
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _mylog = __webpack_require__(3);

var _mylog2 = _interopRequireDefault(_mylog);

var _utils = __webpack_require__(0);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

utils.ready(function () {
  _mylog2.default.init();
});

module.exports = _mylog2.default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _utils = __webpack_require__(0);

var utils = _interopRequireWildcard(_utils);

var _cookie = __webpack_require__(4);

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

var mylog = {
  init: function init() {
    var _this = this;

    this.send();

    utils.ready(function () {
      _this.initAttrLog();
    });
  },

  /**
   * 初始化属性log
   */
  initAttrLog: function initAttrLog() {
    var _this2 = this;

    var name = 'data-mylog';

    utils.on(document.body, 'click', function (event) {
      var target = event.target;

      while (!target.getAttribute(name) && target.tagName !== 'BODY') {
        target = target.parentElement;
      }

      if (target.tagName !== 'BODY') {
        _this2.send(target.getAttribute(name));
      }
    });
  },

  /**
   * 自定义事件名字，不传参数
   * @param {string} name 发送事件名字
   * @param {object} param 参数
   * @config {string} source 来源
   */
  send: function send(name, param) {
    var params = {
      et: 'pageview'
    };

    if (name) {
      params = {
        etn: name,
        et: 'event'
      };

      // 自定义事件添加参数
      if (utils.isObject(param)) {
        params = _extends(params, {
          etp: encodeURI(JSON.stringify(param))
        });
      }
    }

    this.sendIMG(params);
  },

  /**
   * 生成唯一ID
   * @return {string}
   */
  unique: function unique() {
    var name = '__MYLOG_UID';
    var uid = _cookie2.default.get(name);

    if (!uid) {
      uid = utils.guid();
      _cookie2.default.set(name, uid, {
        expires: 10 * 12 * 30,
        path: '/'
      });
    }

    return uid;
  },

  /**
   * 会话ID
   * @return {string}
   */
  sessionId: function sessionId() {
    var name = '__MYLOG_SID';
    var sid = _cookie2.default.get(name);

    if (!sid) {
      sid = utils.guid();
      _cookie2.default.set(name, sid, {
        path: '/'
      });
    }

    return sid;
  },

  /**
   * 获取当前链接
   * @return {string}
   */
  getURL: function getURL() {
    return window.location.href;
  },

  /**
   * 获取屏幕尺寸
   * @return {string}
   */
  getScreenSize: function getScreenSize() {
    var width = window.screen.width || 0;
    var height = window.screen.height || 0;
    return width + 'x' + height;
  },

  /**
   * 获取语言
   * @return {string}
   */
  getLanguage: function getLanguage() {
    var type = navigator.appName;
    var lang = '';

    if (type === 'Netscape') {
      lang = navigator.language;
    } else {
      lang = navigator.userLanguage;
    }

    return lang;
  },

  /**
   * 发送图片
   * @param {object} params  url参数
   */
  sendIMG: function sendIMG(params) {
    var host = utils.getProtocol() + '://skynet.iyunbao.com/open/v1/data/1.png';
    var img = new Image();
    var initParam = {
      // 当前页面的链接地址
      url: this.getURL(),
      // 页面标题
      te: document.title,
      // 用户唯一Id，用作UV
      uid: this.unique(),
      // 临时（会话）ID
      sid: this.sessionId(),
      // 请求时间戳
      ts: utils.timestamps(),
      // 语言
      lg: this.getLanguage(),
      // 屏幕宽高
      ds: this.getScreenSize()
    };

    initParam = _extends(initParam, params);

    img.src = '' + host + utils.objectToUrl(initParam);

    img.onload = function () {
      img.onload = null;
    };
  }
};

exports.default = mylog;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(0);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

var cookie = {
  /**
   * 获取cookie的值,不对值进行解码
   * @name hp.cookie.getRaw
   * @param {string} key    目标参数
   */
  getRaw: function getRaw(key) {
    if (cookie._isValidKey(key)) {
      var reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
      var result = reg.exec(document.cookie);
      if (result) {
        return result[2] || null;
      }
    }
    return null;
  },

  /**
   * 获取cookie的值,用decodeURIComponent进行解码
   * @name hp.cookie.get
   * @param {string} key      目标参数
   */
  get: function get(key) {
    var value = cookie.getRaw(key);
    if (typeof value === 'string') {
      value = decodeURIComponent(value);
      return value;
    }
    return null;
  },

  /**
   * 设置cookie的值,不对值进行解码
   * @name hp.cookie.setRaw
   * @param {string} key           目标参数
   * @param {string} value         设置参数值
   */
  setRaw: function setRaw(key, value, options) {
    if (!cookie._isValidKey(key)) {
      return;
    }

    options = options || {};
    // options.path = options.path || "/"; // meizz 20100402 设定一个初始值，方便后续的操作
    // berg 20100409 去掉，因为用户希望默认的path是当前路径，这样和浏览器对cookie的定义也是一致的

    // 计算cookie过期时间
    var _options = options,
        expires = _options.expires;

    if (typeof expires === 'number') {
      expires = new Date(utils.timestamps() + expires * 24 * 60 * 60 * 1000);
    }

    document.cookie = key + '=' + value + (options.path ? '; path=' + options.path : '') + (expires ? '; expires=' + expires.toGMTString() : '') + (options.domain ? '; domain=' + options.domain : '') + (options.secure ? '; secure' : '');
  },

  /**
   * 设置cookie的值,用decodeURIComponent进行解码
   * @name hp.cookie.set
   * @param {string} key           目标参数
   * @param {string} value         设置参数值
   */
  set: function set(key, value, options) {
    cookie.setRaw(key, encodeURIComponent(value), options);
  },

  /**
   * 删除cookie的值
   * @name hp.cookie.remove
   * @param {string} key           目标参数
   */
  remove: function remove(key, options) {
    options = options || {};
    options.expires = new Date(0);
    cookie.setRaw(key, '', options);
  },
  _isValidKey: function _isValidKey(key) {
    return new RegExp('^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+$').test(key);
  }
};

exports.default = cookie;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// mylog-1.0.0.min.js